import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'nrwl-bulletin-popup',
  templateUrl: './bulletin.popup.component.html',
  styleUrls: ['./bulletin.popup.component.scss']
})
export class BulletinPopupComponent {
  title: string;
  message: string;
  constructor(
    public dialogRef: MatDialogRef<BulletinPopupComponent>,
    @Inject(MAT_DIALOG_DATA) data //eslint-disable-line
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  close(response: string): void {
    this.dialogRef.close(response);
  }
}
